import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoursesService, RestApiService } from '@draeger-academy/common';
import { HeaderModule } from '../header';
import { AutoCompleteListItemInterface } from './interfaces/auto-complete.interfaces';

@Injectable({ providedIn: 'any' })
export class AutoCompleteV3Service {
    constructor(private _restApiService: RestApiService, private _coursesService: CoursesService) {}

    public getHighlightedString(result: AutoCompleteListItemInterface, searchTerm: string): string {
        if (!searchTerm) {
            return result.label;
        }
        const currentSearchTerms = searchTerm
            .trim()
            .replace(/ +/g, ' ')
            .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            .split(' ')
            .join('|');
        const searchRegExp = new RegExp(`(^(${currentSearchTerms})|\\W(${currentSearchTerms}))`, 'gi');
        return result.label.replace(searchRegExp, (matched) => {
            return matched.charAt(0) === ' ' ? ` <strong>${matched.slice(1)}</strong>` : `<strong>${matched}</strong>`;
        });
    }

    public getSuggestions(requestUrl: string, searchString: string, returnReversed: boolean = false) {
        const _options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            responseType: 'json'
        };

        return this._coursesService.getAllCourses().then((data) => {
            let tempResults = [];

            data.forEach((course) => {
                if (course.name.indexOf(searchString) > -1) {
                    let item = {
                        label: course.name,
                        value: course.name
                    };

                    tempResults.push(item);
                }

                if (course.training && course.training.description && course.training.description.indexOf(searchString) > -1) {
                    let item = {
                        label: course.name,
                        value: course.name
                    };

                    tempResults.push(item);
                }

                if (course.events && course.events.length > 0) {
                    course.events.forEach((event) => {
                        if (event.location.city.toLowerCase().toString() === searchString) {
                            let item = {
                                label: course.name,
                                value: course.name
                            };
                            tempResults.push(item);
                        }
                    });
                }
            });

            return tempResults;
        });
    }
}
